import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js'
import {
  Radio,
  Checkbox,
  Button,
  Spinner,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Dialog,
  Alert,
} from '@material-tailwind/react'
import { env } from './env'
import React, { useState } from 'react'
import moment from 'moment'

const CheckoutSection = ({ formData, editPassengerFn, billingDifferent, trip, formLoading }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [selectedOption, setSelectedOption] = useState('plan')
  const [paymentError, setPaymentError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [successModalVisible, setSuccessModalVisible] = useState(false)
  const [finished, setFinished] = useState(false)
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)
  const [terms, setTerms] = useState(false)
  const [termsError, setTermsError] = useState(false)

  const handleSubmit = async (event) => {
    // event.preventDefault()
    setPaymentError(null)
    setConfirmModalVisible(false)
    setLoading(true)

    if (!stripe || !elements) {
      alert('Stripe has not loaded yet.')
      setLoading(false)

      return
    }

    const card = elements.getElement(CardElement)
    const result = await stripe.createPaymentMethod({
      type: 'card',
      card: card,
    })

    if (result.error) {
      setPaymentError(result.error.message)
      console.error(result.error)
    } else {
      // Send the payment method ID to your server for further processing
      // e.g., to associate it with a customer or to charge the customer

      const response = await fetch(`${env.baseUrl}/payments/add-payment-method`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tripId: trip.id,
          paymentMethodId: result.paymentMethod.id,
          last4: result.paymentMethod.card.last4,
          stripeCustomerId: localStorage.getItem('stripeCustomerId'),
          userId: localStorage.getItem('userId'),
          plan: selectedOption,
        }),
      }).catch((err) => {
        setPaymentError('Unable to complete payment')
      })
      if (!response.ok) {
        setPaymentError('Unable to complete payment')
      } else {
        const res = await response.json()
        console.log('RESSS')
        console.log(res)
        if (res) {
          if (res.error) {
            setPaymentError(res.error)
          } else {
            setFinished(true)
            openSuccess()
          }
        } else {
          alert('Unable to complete payment')
        }
      }
    }

    setLoading(false)
  }

  const openSuccess = () => {
    setSuccessModalVisible(true)
  }

  const closeSuccess = () => {
    setSuccessModalVisible(false)
  }
  const openConfirm = () => {
    if (!terms) {
      setTermsError(true)
    } else {
      setConfirmModalVisible(true)
    }
  }

  const closeConfirm = () => {
    setConfirmModalVisible(false)
  }

  return (
    <>
      <h2 className="text-2xl font-bold text-center mb-4">Payment</h2>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div className="flex gap-10 justify-center">
          <Radio
            onChange={(e) => setSelectedOption(e.target.value)}
            name="type"
            label="Full Payment"
            value="full"
            checked={selectedOption === 'full'} />
          <Radio
            onChange={(e) => setSelectedOption(e.target.value)}
            name="type"
            label="Payment Plan (5% Flexible Payment Service Fee)"
            value="plan"
            checked={selectedOption === 'plan'} />
        </div>
        <div className="m-3 mb-8">
          <div id="details" style={{ display: selectedOption === 'full' ? 'block' : 'none' }}>
            <div className="invoice-container">

              <div className="invoice-lineItem">
                <div className="invoice-description">{trip.name} Trip</div>
                <div><strong>£{(trip.price / 100).toFixed(2)}</strong></div>
              </div>
              {trip.damageDepositAmount > 0 ?
                <div className="invoice-lineItem">
                  <div className="invoice-description">Refundable damage deposit</div>
                  <div><strong>£{(trip.damageDepositAmount / 100).toFixed(2)}</strong></div>
                </div>
                : <></>
              }
              <div className="invoice-total">
                <span>Total charged today:</span>
                <strong>£{((trip.price + trip.damageDepositAmount) / 100).toFixed(2)}</strong>
              </div>
              <div style={{ fontSize: 12, color: "#AAA" }}>While prices are displayed in GBP (£), we happily accept a variety of other currencies. Your bank or credit card provider will handle the currency conversion for you, and you’ll be charged in your local currency.</div>
            </div>
          </div>

          <div id="details" style={{ display: selectedOption === 'plan' ? 'block' : 'none' }}>
            <div className="invoice-container">
              <div className="invoice-lineItem">
                <span>Summary of charges:</span>
              </div>
              <div className="invoice-lineItem">
                <div className="invoice-description">Deposit amount billed today.</div>
                <div><strong>£{(trip.depositAmount / 100).toFixed(2)}</strong></div>
              </div>
              {trip && trip.paymentPlan && trip.paymentPlan.sort((a, b) => a.stage - b.stage).map((item, index) => (
                <div key={index} className="invoice-lineItem">
                  <div className="invoice-description">{item.description}</div>
                  <div><strong>£{(item.amount / 100).toFixed(2)}</strong></div>
                </div>
              ))}
              <div className="invoice-total">
                <span>Total:</span>
                <strong>£{(((trip && trip.depositAmount ? trip.depositAmount : 0) + (trip && trip.paymentPlan ? trip.paymentPlan.reduce((sum, item) => sum + (item.amount || 0), 0) : 0)) / 100).toFixed(2)}</strong>

              </div>
              <div style={{ fontSize: 12, color: "#AAA" }}>While prices are displayed in GBP (£), we happily accept a variety of other currencies. Your bank or credit card provider will handle the currency conversion for you, and you’ll be charged in your local currency.</div>
            </div>
          </div>
        </div>
        <div className="m-3">

          <CardElement className="w-full p-2 border rounded" />
          {paymentError && <p className="text-red-500">{paymentError}</p>}

        </div>
        <Checkbox
          label={<><span>By registering for this trip, I agree to the <a className="text-blue-500" target="_blank"
            href="https://thetravelsquad.com/terms-of-use">Terms of Use</a>, {trip.nucoPackageId ? <a
              className="text-blue-500" target="_blank"
              href="https://www.nucotravel.com/en-gb/terms-and-conditions/travelsquad2023?internal-traffic=true">Terms and Conditions</a> : <></>} and <a
                className="text-blue-500" target="_blank"
                href="https://thetravelsquad.com/privacy-policy">Privacy Policy</a> and authorize Travel Squad to charge my card on the aforementioned dates</span></>}
          checked={terms} onChange={() => {
            setTerms(!terms)
            setTermsError(false)
          }}
        />
        {termsError ? <p className="text-red-500">You must agree to the terms and conditions</p> : <></>}

        {/* <Button
          className="text-white rounded w-full mt-8"
          color="blue"
          onClick={() => setFinished(false)}>
          reset
        </Button> */}
        <Button
          className="text-white rounded w-full mt-8"
          color="blue"
          disabled={finished}
          onClick={() => editPassengerFn()}>
          Edit passenger/billing details
        </Button>
        <Button className="text-white rounded w-full mt-4" disabled={!stripe  || formLoading || loading || finished}
          onClick={() => openConfirm()}>
          {loading ? <Spinner /> : 'Continue to Confirm Details'}
        </Button>
        <Dialog
          open={confirmModalVisible}
          handler={openConfirm}
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <div style={{ overflow: 'auto', maxHeight: '80vh' }}>
            <DialogHeader>Confirm Trip Details</DialogHeader>
            <DialogBody>

              <div>
                <div className="confirm-header" style={{ marginTop: -15 }}>Trip</div>
                <div className="confirm-content"><strong>{trip.name}</strong><br />
                  <strong>{moment.utc(trip.start).format("MMM Do") + ' - ' + moment.utc(trip.end).format("MMM Do, YYYY")}</strong><br />
                  <strong>{trip.location}</strong>
                </div>
              </div>

              <div className="confirm-header">Summary of charges</div>

              <div id="details" style={{ display: selectedOption === 'full' ? 'block' : 'none' }}>
                <div className="invoice-container">
                  <div className="invoice-lineItem">
                    <div className="invoice-description">{trip.name} Trip</div>
                    <div><strong>£{(trip.price / 100).toFixed(2)}</strong></div>
                  </div>
                  {trip.damageDepositAmount > 0 ?
                    <div className="invoice-lineItem">
                      <div className="invoice-description">Refundable damage deposit</div>
                      <div><strong>£{(trip.damageDepositAmount / 100).toFixed(2)}</strong></div>
                    </div>
                    : <></>
                  }
                  <div className="invoice-total">
                    <span>Total charged today:</span>
                    <strong>£{((trip.price + trip.damageDepositAmount) / 100).toFixed(2)}</strong>
                  </div>
                </div>
              </div>
              <div id="details" style={{ display: selectedOption === 'plan' ? 'block' : 'none' }}>
                <div className="invoice-container">
                  <div className="invoice-lineItem">
                    <span>Summary of charges:</span>
                  </div>
                  <div className="invoice-lineItem">
                    <div className="invoice-description">Deposit amount billed today.</div>
                    <div><strong>£{(trip.depositAmount / 100).toFixed(2)}</strong></div>
                  </div>
                  {trip && trip.paymentPlan && trip.paymentPlan.sort((a, b) => a.stage - b.stage).map((item, index) => (
                    <div key={index} className="invoice-lineItem">
                      <div className="invoice-description">{item.description}</div>
                      <div><strong>£{(item.amount / 100).toFixed(2)}</strong></div>
                    </div>
                  ))}
                  <div className="invoice-total">
                    <span>Total:</span>
                    <strong>£{(((trip && trip.depositAmount ? trip.depositAmount : 0) + (trip && trip.paymentPlan ? trip.paymentPlan.reduce((sum, item) => sum + (item.amount || 0), 0) : 0)) / 100).toFixed(2)}</strong>
                  </div>
                </div>
              </div>

              <div id="passenger">
                <div className="confirm-header">Passenger</div>
                <div className="confirm-content">
                  <div>{formData.firstName} {formData.lastName}</div>
                  <div>{formData.email}</div>
                  <div>{formData.address}</div>
                  {formData.addressLine2 ? <div>{formData.addressLine2}</div> : <></>}
                  <div>{formData.city}, {formData.state}, {formData.postalZip}, {formData.country}</div>
                  <div>{formData.phone}</div>
                  <div>instagram: {formData.instagramHandle}</div>
                </div>

              </div>
              <div id="billing">
                <div className="confirm-header">Billing</div>
                <div className="confirm-content">
                  {billingDifferent
                    ? <>
                      <div>{formData.billing_firstName} {formData.billing_lastName}</div>
                      <div>{formData.billing_email}</div>
                      <div>{formData.billing_address}</div>
                      {formData.billing_addressLine2 ? <div>{formData.billing_addressLine2}</div> : <></>}
                      <div>{formData.billing_city}, {formData.billing_state}, {formData.billing_postalZip}, {formData.billing_country}</div>
                    </>
                    : <>
                      <div>Billing details are the same as the passenger details.</div>
                    </>
                  }
                </div>
              </div>
            </DialogBody>
            <DialogFooter>
              <Button
                variant="text"
                color="red"
                className="mr-1 mt-4"
                onClick={() => closeConfirm()}
              >
                <span>Cancel</span>
              </Button>
              <Button className="text-white rounded w-full mt-4 mb-4" disabled={!stripe || formLoading || loading || finished}
                onClick={() => handleSubmit()}>
                {loading ? <Spinner /> : 'Confirm & Pay'}
              </Button>
            </DialogFooter>
          </div>
        </Dialog>

        <Dialog
          open={successModalVisible}
          handler={openSuccess}
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogHeader>Success</DialogHeader>
          <DialogBody>
            Your payment was successful! You will receive an email confirmation shortly.
          </DialogBody>
          <DialogFooter>
            <Button className="text-white rounded w-full mt-4" onClick={() => setSuccessModalVisible(false)}>
              Close
            </Button>
          </DialogFooter>
        </Dialog>
      </form>
    </>
  )
}

export default CheckoutSection
